module.exports = __webpack_public_path__ + "img/m_jd.40928403.png";